import * as React from 'react'
import { motion } from 'motion/react'

const AnimatedContainer = ({
  className = '',
  children,
  customViewportAmount,
  mountOnEnter = false,
}) => {
  const [entered, setEntered] = React.useState(false)

  let content
  let props = {}

  if (mountOnEnter) {
    props.animate = entered ? 'visible' : 'hidden'
    props.onViewportEnter = () => setEntered(true)

    content = entered ? children : null
  } else {
    props.whileInView = 'visible'

    content = children
  }

  return (
    <motion.div
      className={className}
      initial='hidden'
      viewport={{ once: true, amount: customViewportAmount || 0.5 }}
      variants={{
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            ease: 'easeInOut',
            staggerChildren: 0.25,
          },
        },
      }}
      {...props}
    >
      {content}
    </motion.div>
  )
}

export default AnimatedContainer
